import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import videoFile from './13-eva.webm';
import audioFile from './14-eva-song.mp3';
import qrLinkedIn from '/assets/images/qr-LinkedIn.png';

export const slide = () => {
  return (
    <Slide
      notes="EVA video demonstration"
      transition="fade"
      audio={audioFile}
      visualizer="full"
      background={{
        video: videoFile,
      }}
    >
      <div className="relative z-10 flex items-center justify-center h-full">
        <h1 className="text-8xl font-light text-white tracking-wider">EVA</h1>
      </div>
      <WebContent
        animation={{
          type: 'fade',
          delay: 4000,
          duration: 1200,
        }}
      >
        <div className="fixed right-[14%] top-1/2 z-20" style={{ transform: 'translateY(-50%)' }}>
          <img src={qrLinkedIn} alt="LinkedIn QR Code" className="w-96 object-contain" />
        </div>
      </WebContent>
    </Slide>
  );
};
